module.exports = __webpack_public_path__ + "media/logos/msnb-logo-black-4c71bad1.png";